// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"ChartSelector_thumbnail__1xQ_-","currentChart":"ChartSelector_currentChart__NKILM","disabled":"ChartSelector_disabled__MRXKu"};